<template>
  <div class="_list_0">
    <h4 class="_title_0">
      <a
        :href="'/ticket-vue/ticket/view?ticketType=3&viewId=' + view.id"
        target="_blank"
      >{{view.name}}({{ticketCount}})</a>
    </h4>

    <el-table :show-header="false" :data="ticketList" border highlight-current-row>
      <el-table-column>
        <template slot-scope="scope">
          <TicketTitle :ticketTitle="scope.row.orderTitle" :ticketNo="scope.row.orderId" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "DashboardTicketTable",

  props: ["view"],

  data() {
    return {
      ticketList: [],
      ticketCount: null
    };
  },

  methods : {
    // 为了排列整齐,不够的加一些空数据
    topUp(_list) {
      var len = _list.length;
      for(var i = 0; i < 10-len; i++) {
        _list.push({
          orderTitle : ' '
        });
      }

      return _list;
    }
  },

  mounted() {
    var _this = this;

    sdk.TicketApi().list({
        viewId: _this.view.id,
        page: { pageNumber: 1, pageSize: 10 }
      }).then(res => {
        _this.ticketList = _this.topUp(res.list);
        _this.ticketCount = res.recordCount;
      });
  }
};
</script>

<style scoped>
._title_0 {
  text-align: center;
  border: 1px solid #ebeef5;
  border-bottom-width: 0;
  margin: 10px 0 0 0;
  padding: 12px;
  background-color: #e7ecf025;
}
</style>


// WEBPACK FOOTER //
// src/components/ticket/DashboardTicketTable.vue